import M_COLLECT from './collect/index.js'
import M_DATA from './data/index.js'
import M_REPORT from './report/index.js'
import M_STRATEGY from './strategy/index.js'

export default {
    M_COLLECT,
    M_DATA,
    M_REPORT,
    M_STRATEGY
}
